import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const successToast = (
  message: string,
  seconds = 0,
  position?:
    | 'top-right'
    | 'top-center'
    | 'top-left'
    | 'bottom-right'
    | 'bottom-center'
    | 'bottom-left',
  callback?: () => void
) =>
  toast.success(message, {
    position: position || 'top-center',
    autoClose: seconds * 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClose: callback,
  });

export const errorToast = (
  message: string,
  seconds = 0,
  position?:
    | 'top-right'
    | 'top-center'
    | 'top-left'
    | 'bottom-right'
    | 'bottom-center'
    | 'bottom-left',
  callback?: () => void
) =>
  toast.error(message, {
    position: position || 'top-center',
    autoClose: seconds * 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClose: callback,
  });

export const infoToast = (
  message: string,
  seconds = 0,
  position?:
    | 'top-right'
    | 'top-center'
    | 'top-left'
    | 'bottom-right'
    | 'bottom-center'
    | 'bottom-left',
  callback?: () => void
) =>
  toast.info(message, {
    ...(position && { position: position || 'top-right' }),
    autoClose: seconds * 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClose: callback,
  });
